import React from 'react'
import { ThemeProvider } from 'styled-components'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import { personCustomerType } from '../constants/GeneralConstants'
import favicon from '../images/favicon.png'
import { GlobalStyle } from '../styles/global'
import theme from '../styles/theme'
import config from '../utils/siteConfig'

class Layout extends React.Component {

    render() {
        const { children, locale, metaTagTitle, customerType } = this.props

        return (
            <div className="siteRoot" style={customerType === personCustomerType ? {maxWidth: '1400px', margin: '0 auto'} : {}}>
              <>
                <Helmet>
                    <title>{metaTagTitle || config.siteTitle}</title>
                    <meta charSet="utf-8" />
                    <meta name="viewport" content="width=device-width, initial-scale=1" />
                    <link rel="icon" type="image/png" href={favicon} />
                    <link rel="preconnect" href="https://fonts.googleapis.com" />
                    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
                    <link href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap" rel="stylesheet" />
                    <meta name="description" content={config.siteDescription} />
                    <meta property="og:title" content={config.siteTitle} />
                    <meta property="og:locale" content={locale} />
                    <meta property="og:type" content="website" />
                    <meta property="og:site_name" content={config.siteTitle} />

                </Helmet>
                <ThemeProvider theme={theme}>
                  <>

                    <div className="siteContent">
                        {children}
                    </div>

                      <GlobalStyle />
                  </>
                </ThemeProvider>
              </>
            </div>
        )
    }
}

Layout.propTypes = {
    children: PropTypes.array,
    locale: PropTypes.string,
    customerType: PropTypes.string,
    metaTagTitle: PropTypes.string
}

Layout.defaultProps = {
    footer: true,
    header: true
}

export default Layout
